import { ICarousel } from '@common/types/element';
import { filter, pick } from 'lodash';
import querystring from 'query-string';
import { Platform } from 'react-native';
import { getValueBinding } from '../shared';

export const getCarouselItemList = (attrs: ICarousel) => {
  const { dataBinding, attributes, databaseOptions } = attrs;

  const search = querystring.parse(window?.location?.search);
  const target = search?.target;
  if (Platform.OS === 'web' && !target) {
    // canvas case
    return (
      dataBinding ??
      Array.from(Array(3), () => (dataBinding ? dataBinding[0] : ''))
    );
  } else {
    // get image from element config
    const bindingValue: Record<string, any> =
      getValueBinding('', dataBinding[0] || {}, attrs) || {};
    const imageFromTail = filter(
      pick(
        bindingValue,
        Array.from(Array(6).keys()).map(
          (number) => `customImage.image${number}`
        )
      )
    );
    const customImageEnabled =
      attributes.customImage?.enabled !== false &&
      attributes.customImage?.enabled !== 'false';
    // case of not use database
    if (!databaseOptions?.id && customImageEnabled) {
      return Object.values(imageFromTail).map((item: string) => ({
        cardCover: {
          imageUrl: item,
        },
      }));
    } else {
      // case of use database
      if (customImageEnabled) {
        return [
          ...(dataBinding ?? []),
          ...Object.values(imageFromTail).map((item: string) => ({
            cardCover: {
              imageUrl: item,
              image: {
                url: item,
              },
            },
          })),
        ];
      }
      return dataBinding ?? [];
    }
  }
};
